/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { RadioStyle } from "@insite/mobius/Radio";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { xBaseTheme } from "@monsma/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        typographyProps: {
            disabledColor: "text",
            size: 13,
            lineHeight: "16px",
        },
        css: css`
            display: inline-flex;
            & + & {
                margin-top: 0px;
            }
            input {
                width: 0;
                height: 0;
                margin: 0;
                position: absolute;
                & + label {
                    margin-left: 0;
                    &::before {
                        width: 17px;
                        height: 17px;
                        margin-right: 8px;
                        flex-shrink: 0;
                        border-color: ${getColor("common.ui9")};
                        background: ${getColor("common.ui7")};
                    }
                }
                &:checked:not(:disabled) + label {
                    &::before {
                        border-color: ${getColor("common.ui9")};
                        background: ${getColor("common.ui7")};
                    }
                }
                &:focus + label::before {
                    box-shadow: none;
                }
                &:checked + label::after {
                    height: 13px;
                    width: 13px;
                    background: ${getColor("common.ui4")};
                    left: 2px;
                    top: 2px;
                }
                &:checked:disabled + label::before {
                }
                &:checked:disabled + label::after {
                    background: ${getColor("common.ui4")};
                }
                &:disabled + label {
                    opacity: 0.33;
                }
                &:hover:not(:disabled) {
                    & + label::before {
                        border-color: ${getColor("common.ui3")};
                    }
                }
            }
        `,
    },
    groupDefaultProps: {
        labelProps: {
            size: 14,
            lineHeight: "20px",
            weight: "bold",
            css: css`
                &:empty {
                    display: none;
                }
            `,
        },
        errorProps: {
            size: 13,
            lineHeight: "22px",
            weight: "bold",
            css: css`
                &:empty {
                    display: none;
                }
            `,
        },
        css: css`
            ${({ disabled }: any) => disabled && `opacity:0.33`};
            & > ${TypographyStyle as any} {
                padding: 0;
                &:first-child {
                    margin-bottom: 20px;
                }
                &:last-child {
                    margin-top: 10px;
                }
            }
            ${/* sc-selector */ RadioStyle} + ${/* sc-selector */ RadioStyle} {
                margin-top: 20px;
            }
            &.inline-group {
                display:flex;
                flex-direction: row;
                flex-wrap: wrap;
                margin: -5px -10px;
                & > ${TypographyStyle as any} {
                    flex-basis: 100%;
                    padding: 5px 10px;
                    &:first-child {
                        margin-bottom: 5px;
                    }
                    &:last-child {
                        padding-top: 0;
                    }
                }
                ${/* sc-selector */ RadioStyle} + ${/* sc-selector */ RadioStyle} {
                   margin-top: 0px;
                }
                ${/* sc-selector */ RadioStyle} {
                    padding: 5px 10px;
                }
            }
        `,
    },
} as xBaseTheme["radio"];
